import React from 'react';
import { Box } from '@mui/material';
import { Trans } from '@lingui/macro';

import { EPositionType, IEnrichedUniswapPosition } from '../../../../types/uniswapTokens';
import { FormattedNumber } from '../../../primitives/FormattedNumber';
import { MobileItemWrapper } from '../../MobileItemWrapper';
import { useEstAprValues } from '../../hooks/useEstAprValues';
import { MobileValueRow } from '../MobileValueRow';

export interface IUniswapPositionsListItem {
  position: IEnrichedUniswapPosition;
  actions: (args: {
    position: IEnrichedUniswapPosition;
    tokenId?: string;
    positionAddress?: string;
    isEmptyPosition?: boolean;
    uniswapLink?: string;
  }) => React.ReactNode;
  columnsType: 'lending' | 'leverage' | 'leveraged';
}

export const AlmPositionsListItemMobile = ({ position, actions }: IUniswapPositionsListItem) => {
  const { estNetApr } = useEstAprValues({ position });

  return (
    <MobileItemWrapper
      position={position}
      marketName={position.marketName}
      almMarketName={position.almMarket?.marketName}
    >
      <MobileValueRow caption={<Trans>Liquidity</Trans>}>
        <FormattedNumber
          value={position.marketReferenceCurrencyValue}
          symbol="USD"
          variant="secondary14"
          compact
        />
      </MobileValueRow>
      <MobileValueRow caption={<Trans>Debt Value</Trans>}>
        <FormattedNumber
          value={position.marketReferenceCurrencyDebt || 0}
          symbol="USD"
          variant="secondary14"
          compact
        />
      </MobileValueRow>
      <MobileValueRow caption={<Trans>Net Worth</Trans>}>
        <FormattedNumber
          value={position.token0.netWorthUsd + position.token1.netWorthUsd}
          symbol="USD"
          variant="secondary14"
          compact
        />
      </MobileValueRow>
      <MobileValueRow caption={<Trans>Est. Net APR</Trans>}>
        <FormattedNumber
          value={estNetApr}
          variant="secondary14"
          color={estNetApr > 0 ? 'text.brand' : 'text.tertiary' }
          symbolsColor={estNetApr > 0 ? 'text.brand' : 'text.tertiary' }
          percent
          compact
        />
      </MobileValueRow>
      <MobileValueRow caption={<Trans>Health</Trans>}>
        <FormattedNumber
          value={position.healthFactor || 0}
          variant="secondary14"
          compact
        />
      </MobileValueRow>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 3 }}>
        {actions({
          position,
          tokenId: position.tokenId.toString(),
          positionAddress: position.positionAddress,
          isEmptyPosition: position.type === EPositionType.Pool,
          uniswapLink: position.uniswapLink,
        })}
      </Box>
    </MobileItemWrapper>
  );
};
